// src/components/AdminLogin.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './Login.css'; // Puedes usar el mismo CSS o crear uno distinto

// URL de la API desde el archivo .env
const apiUrl = process.env.REACT_APP_API_URL || 'https://www.nualily.es';

const AdminLogin = ({ setIsAuthenticated, setIsAdmin }) => {
  const [adminCredentials, setAdminCredentials] = useState({ name: '', password: '', phone: '' });
  const navigate = useNavigate();

  useEffect(() => {
    // Si ya hay un token en el localStorage, asume que el admin está autenticado
    if (localStorage.getItem('token') && localStorage.getItem('isAdmin') === 'true') {
      setIsAuthenticated(true);
      setIsAdmin(true);
      navigate('/'); // Redirige adonde desees (ej. a la ruta principal)
    }
  }, [setIsAuthenticated, setIsAdmin, navigate]);

  const handleAdminChange = (e) => {
    const { name, value } = e.target;
    setAdminCredentials(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${apiUrl}/api/admin/login`, adminCredentials);
      // Guarda los datos en localStorage
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('isAdmin', 'true');
      setIsAuthenticated(true);
      setIsAdmin(true);
      navigate('/'); // Redirige al home o a una ruta de dashboard de admin, como prefieras
    } catch (error) {
      console.error('Error de inicio de sesión de administrador:', error);
      alert(
        'Error en el inicio de sesión de administrador: ' +
        (error.response?.data?.message || error.message)
      );
    }
  };

  return (
    <div className="login-container">
      <div className="logo-container">
        <div className="jewel-icon"></div> {/* Icono de joya (opcional) */}
        <p className="slogan">Panel de Administración</p>
      </div>
      <form onSubmit={handleSubmit} className="login-form">
        <input
          type="text"
          name="name"
          placeholder="Nombre de Administrador"
          value={adminCredentials.name}
          onChange={handleAdminChange}
          required
        />
        <input
          type="password"
          name="password"
          placeholder="Contraseña"
          value={adminCredentials.password}
          onChange={handleAdminChange}
          required
        />
        <input
          type="text"
          name="phone"
          placeholder="Número de Teléfono"
          value={adminCredentials.phone}
          onChange={handleAdminChange}
          required
        />
        <button type="submit">Iniciar como Administrador</button>
      </form>
    </div>
  );
};

export default AdminLogin;
